import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import Shop from "./3rdretailicons.svg";
import Truck from "./3rdretailicons1.svg";
import Money from "./3rdretailicons3.svg";
import Ship from "./3rdretailicons4.svg";
import Flag from "./3rdretailicons6.svg";

function Whatwedo() {
  useEffect(() => {
    Aos.init({ duration: 500 });
  }, []);

  return (
    <div data-aos='fade-up'>
      <div className='container mx-auto sec-pad section-whatwedo brand-bg '>
        <div>
          <h4 className='fs-3x fs-lg-3x mb-8'>Our Services</h4>
        </div>

        <div className='row g-5 g-xl-8'>
          <div className='col-xl-4'>
            <div className='card card-sec card-xl-stretch mb-xl-8'>
              <div className='card-body'>
                <img src={Shop} alt='img' width='70px' height='70px' />

                <div className='fw-bold text-copy fs-sm-1x cardtext mb-2 mt-5'>
                  Franchise Advisory Services
                </div>
              </div>
            </div>
          </div>
          <div className='col-xl-4'>
            <div className='card card-sec card-xl-stretch mb-xl-8'>
              <div className='card-body'>
                <img src={Truck} alt='img' width='70px' height='70px' />

                <div className='cardtext text-copy fw-bold mb-2 mt-5'>
                  Distribution/Retail Channels Development and Management
                </div>
              </div>
            </div>
          </div>
          <div className='col-xl-4'>
            <div className='card card-sec card-xl-stretch mb-5 mb-xl-8'>
              <div className='card-body'>
                <img src={Money} alt='img' width='70px' height='70px' />
                <div className='cardtext text-copy fw-bold mb-2 mt-5'>
                  Sales and Marketing Support
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row g-5 g-xl-8'>
          <div className='col-xl-4'>
            <div className='card card-sec card-xl-stretch mb-5 mb-xl-8'>
              <div className='card-body'>
                <img src={Ship} alt='img' width='70px' height='70px' />
                <div className='fw-bold text-copy cardtext mb-2 mt-5'>
                  New Market Frontiers
                </div>
              </div>
            </div>
          </div>
          <div className='col-xl-4'>
            <div className='card card-sec card-xl-stretch mb-xl-8'>
              <div className='card-body'>
                <img src={Flag} alt='img' width='70px' height='70px' />
                <div className='cardtext text-copy fw-bold mb-2 mt-5'>
                  Distributions Channels Operations and Risk Audit
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Whatwedo;
